export default {
    computed: {
        activeItem() {
            return this.uniqueItems.find(item => item.val === this.value);
        },
        uniqueItems() {
            return this.items.map((item, idx) => {
                const name = this.id || item.name;
                const id = `${ this.id }-${ idx }`;
                const label = item.label || item.val;

                return {
                    ...item,
                    ...{ id, label, name },
                };
            });
        },
    },
};
